/**
 * ios webview 橡皮筋效果开关
 * @param {bool} close
 */
export default function iosWebViewRebound(close) {
    if (close === void 0) {
        close = true;
    }
    try {
        if (window.CSNativeObject.getOSType() === 'iPhone') {
            window.CSNativeObject.configWebView(JSON.stringify({
                bounces: close,
            }));
        }
    }
    catch (error) { }
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/app/iosWebViewRebound.js
// module id = null
// module chunks = 